import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../../components/Common/Button';
import Guide from '../../../components/Common/Guide';
import ImageCreditsLimitPopup from '../../../components/Common/ImageCreditsLimitPopup';
import InformNotificationPopup from '../../../components/Common/InformNotificationPopup';
import PageModal from '../../../components/PageModal/PageModal';
import TitleModal from '../../../components/TitleModal/TitleModal';
import { UserLocalStorageKeysEnum } from '../../../interfaces/user.interface';
import { setBookDataModified, setIsTitleModalOpen, updateBookData } from '../../../store/appSlice';
import { AppDispatch, RootState } from '../../../store/store';
import TrainingPopup from '../../trainingvideos/TrainingPopup';
import { StepStoryBuilderProps } from '../models/StepStoryBuilderProps.interface';
import { updateUser } from '../services/character.service';
import { updateBookAuthorName, updateBookTitle } from '../services/story.service';
import ChooseCover from './ChooseCover';
import StoryPages from './StoryPages';

const StepStoryBuilder = ({
  setLoadingStatus,
  setStateData,
  setShowImageHistory,
  setShowLowCreditModal,
  closeLowCreditModal,
  setBookTitle,
  setMode,
  setModalOpen,
  setModalMode,
  setShowBookCover,
  setSelectedCoverUrl,
  showLowCreditModal,
  showImageHistory,
  showBookCover,
  showStoryForm,
  stateData,
  bookId,
  bookData,
  bookTitle,
  imagesGenerated,
  selectedCoverUrl,
  loader,
  loaderImageGeneration,
  startStepSix,
  currentStep,
  draftId,
  mode,
  modalMode,
  modalOpen,
  resetStory,
  displayBookPages,
  summaryModal,
  setSummaryModal,
  setShowStoryForm,
  setimageCharacterPrompt,
  imageCharacterPrompt,
  setShowCharacterLibrary,
  onRetryPageGeneration,
  onGoBackToCharacter,
}: StepStoryBuilderProps) => {
  const [editing, setEditing] = useState({
    isPortraitDeleted: false,
    bookId: null,
    pageIndex: null,
    pageData: null,
    type: null,
    index: null,
  });
  const storyData = useSelector((state: RootState) => state.story.storyData);
  const isTitleModalOpen = useSelector((state: RootState) => state.app.isTitleModalOpen);
  const user = useSelector((state: RootState) => state.user.user);
  const trainingVideos = useSelector((state: RootState) => state.user.trainingVideos);
  const [showEditTextIllustration, setShowEditTextIllustration] = useState<boolean>(false);
  const [showEditEditor, setShowEditEditor] = useState<boolean>(false);
  const [originalBookAuthor, setBookAuthor] = useState<string>('');
  const [customBookAuthor, setCustomBookAuthor] = useState<string>('');
  const dispatch: AppDispatch = useDispatch();

  const [selectedPage, setSelectedPage] = useState(null);
  const editMode = localStorage.getItem(UserLocalStorageKeysEnum.EDIT_MODE);

  const bookAuthor = () => customBookAuthor || originalBookAuthor;

  const closeTitleModal = (): void => {
    dispatch(setIsTitleModalOpen(false));
  };
  const openTitleModal = (): void => {
    dispatch(setIsTitleModalOpen(true));
  };

  const openModal = (pageIndex: number, pageData: any, modalMode: any, index = 0): void => {
    setSelectedPage({ ...pageData, pageIndex, index });
    setModalOpen(true);
    setModalMode(modalMode);
  };

  const closeModal = (): void => {
    setModalOpen(false);
    setSelectedPage(null);
  };

  const updateTitle = async (newTitle: string): Promise<void> => {
    try {
      await updateBookTitle(bookId!, newTitle);

      if (editMode === 'yes') {
        dispatch(setBookDataModified(true));
      }

      setBookTitle(newTitle);
      displayBookPages();
    } catch (error) {}
  };

  const updateAuthorNameForBook = async (authorName: string): Promise<void> => {
    try {
      setCustomBookAuthor(authorName);
      await updateBookAuthorName(bookId!, authorName);
      dispatch(updateBookData({ authorName }));

      if (editMode === 'yes') {
        dispatch(setBookDataModified(true));
      }
      displayBookPages();
    } catch (error) {
      console.error('Error updating author name:', error);
      setCustomBookAuthor('');
    }
  };

  useEffect(() => {
    if (bookId !== bookData?.bookId) {
      return;
    }
    if (originalBookAuthor) {
      return;
    }
    if (bookData?.authorName || bookData?.author) {
      setBookAuthor(bookData.authorName || bookData.author || '');
    } else {
      if (Object.keys(bookData.pages || {}).length > 0 && user) {
        setBookAuthor(user?.firstName + ' ' + user?.lastName || '');
      }
    }
  }, [bookId, bookData, user, originalBookAuthor]);

  useEffect(() => {
    return () => {
      setBookAuthor('');
    };
  }, []);

  const [showPopUp, setshowPopUp] = useState<boolean>(true);

  const onClose = async () => {
    await updateUser(user, 'screen3');
    setshowPopUp(false);
  };

  return (
    <>
      <div className="text-left p-4 mb-8 text-sm text-storyblue animate__animated animate__slideInRight">
        {showPopUp &&
          !user?.isTeacherMode &&
          user?.showTrainingPopup &&
          user?.showTrainingPopup['screen3'] === true && (
            <TrainingPopup
              videoUrl={currentStep === 3 ? trainingVideos?.STORY_EDITOR_VIDEO : null}
              onClose={onClose}
              showScreenName={'screen3'}
              className="top-4"
            />
          )}
        {currentStep < 3 && (
          <div className=" w-full flex justify-between mb-2 flex-wrap">
            <div className=" flex items-center align-end mb-4">
              <h2 className="text-left text-2xl  md:text-4xl  font-bold text-storyblue">
                {showImageHistory
                  ? 'Image Library'
                  : showBookCover
                    ? 'Book Cover'
                    : showEditTextIllustration && editing?.type === 'editPrompt'
                      ? 'Build My Illustration'
                      : 'Build My Story'}
              </h2>
              <div>
                <Guide />
              </div>
            </div>

            <div className="flex flex-row flex-wrap gap-2">
              {stateData?.showDownloadPDF && !summaryModal && (
                <>
                  <Button
                    id="step-next-button"
                    title={`${
                      user?.plan?.freePhysicalBookStatus === true &&
                      +(user?.freePhysicalBookCreated ? user?.freePhysicalBookCreated : 0) <
                        +(user?.freePhysicalBookQuantity ?? 0)
                        ? 'Flip Book / Redeem Book'
                        : 'Flip Book / Purchase Book'
                    }`}
                    tooltip={imagesGenerated ? 'Flip Book' : 'Download PDF Once All Images Generated'}
                    disabled={!imagesGenerated}
                    loader={loader}
                    onClick={() => startStepSix()}
                    className={`submit-button bg-storyblueSecondLightText text-white font-bold rounded-2xl px-4 text-sm ${
                      imagesGenerated ? '' : 'opacity-50'
                    }`}
                  />
                </>
              )}
            </div>
          </div>
        )}
        <p
          className={`${currentStep !== 3 && 'mb-6'} text-left text-sm  ${
            showEditTextIllustration && editing?.type === 'editPrompt' ? 'text-red-600' : 'text-storyblue'
          }`}
        >
          {showImageHistory
            ? 'The Image Library stores images that were created for your story that are no longer being used in the story you are creating.  This will allow you to revert back to a previous image or use an image on a different page'
            : showEditTextIllustration && editing?.type === 'editPrompt'
              ? `You can modify your illustration with an existing character or add a new character to your story by 
              editing the prompt text and/or selecting "Select New Character" for the illustration. Then select "New Image".`
              : ``}
          {/*{`We're excited to build your personalized childrens book's storyline and illustrations. Our*/}
          {/*        Builder will create your story and illustrations that will be available for review*/}
          {/*        shortly. We'll showcase the story for your review, and the illustrations will be revealed*/}
          {/*        as soon as our Builder completes each one.`}*/}
        </p>
        {/*{showStoryForm && !showBookCover && currentStep === 3 && (*/}
        {/*  <div*/}
        {/*    className="hidden md:flex justify-center gap-4 rounded bg-white w-full p-2 my-3  lg:hidden">*/}
        {/*    <div className="cursor-pointer" onClick={() => setMode(ListViewMode.GRID)}>*/}
        {/*      <FontAwesomeIcon*/}
        {/*        icon={faGrip}*/}
        {/*        className=" text-3xl text-storyblue"*/}
        {/*        title="Switch to Page Mode"*/}
        {/*      />*/}
        {/*      <p className="text-storyblue">Grid</p>*/}
        {/*    </div>*/}
        {/*    <div className="cursor-pointer" onClick={() => setMode(ListViewMode.PAGE)}>*/}
        {/*      <FontAwesomeIcon*/}
        {/*        icon={faFileLines}*/}
        {/*        className=" text-3xl text-storyblue"*/}
        {/*        title="Switch to Page Mode"*/}
        {/*      />*/}
        {/*      <p className="text-storyblue">Page</p>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*)}*/}
        {(!bookData ||
          !bookData?.pages ||
          Object.values(bookData?.pages).some((data) => !data?.text || !data?.scene)) &&
          !storyData?.storybuildingError && (
            <div>
              <label className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50">
                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                  <img className="w-24 h-24 mb-3" src="/loading.gif" alt="Loading" />
                  <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                    <span className="font-semibold">Loading book and generating images ...</span>
                  </p>
                </div>
              </label>
            </div>
          )}
        {storyData?.storybuildingError && (
          <div>
            <div className="flex flex-col items-center justify-center w-full h-64 border-2 border-red-300 border-dashed rounded-lg bg-red-50">
              <div className="flex flex-col items-center justify-center pt-5 pb-6 px-4 text-center">
                <svg className="w-12 h-12 mb-3 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
                </svg>
                <p className="mb-2 text-sm text-red-600 font-semibold">
                  Something went wrong generating your story.
                </p>
                <p className="mb-4 text-xs text-red-500">
                  Don't worry — your progress is saved. You can try again or go back to make changes.
                </p>
                <div className="flex gap-3">
                  {onGoBackToCharacter && (
                    <button
                      onClick={onGoBackToCharacter}
                      className="px-5 py-2 rounded-full text-sm font-bold bg-white border border-gray-300 text-gray-700 hover:bg-gray-50 transition shadow-sm"
                    >
                      Go Back
                    </button>
                  )}
                  {onRetryPageGeneration && (
                    <button
                      onClick={onRetryPageGeneration}
                      className="px-5 py-2 rounded-full text-sm font-bold text-white bg-storyblueSecondLightText hover:shadow-md transition shadow-sm"
                    >
                      Try Again
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
        {bookData &&
          bookData?.pages &&
          Object.values(bookData?.pages).every((data) => !!data?.text && !!data?.scene) && (
            <div className="max-w-8xl py-0 mx-auto animate__animated animate__backInUp">
              {!showBookCover && !showEditTextIllustration && (
                <div className="w-full rounded-xl pl-4 pr-4 pb-4 mb-4">
                  <div className="flex justify-between items-center">
                    <h2 className="text-2xl md:text-4xl font-serif text-left font-bold flex lg:w-auto lg:items-end lg:flex-row w-full items-center flex-col">
                      <div className="flex items-center">
                        {bookData?.title}{' '}
                        <button
                          onClick={openTitleModal}
                          aria-label="Edit title"
                          title="Edit title"
                          className="hover:opacity-80 transition-opacity cursor-pointer mx-6"
                        >
                          <img src="/controls/edit-title-icon.svg" alt="" className="w-6" />
                        </button>
                      </div>
                      <p className="text-xs text-gray-600 text-opacity-60 text-center">BOOK ID: {bookId}</p>
                    </h2>
                    {/*<ListViewModeSwitcher mode={mode} setMode={setMode}></ListViewModeSwitcher>*/}
                  </div>
                  <TitleModal
                    title={bookTitle}
                    isTitleModalOpen={isTitleModalOpen}
                    onSave={updateTitle}
                    onClose={closeTitleModal}
                  />
                  <div className="flex flex-col md:flex-row justify-between md:items-end mt-2">
                    <h2 className="text-base md:text-xl font-serif text-left flex lg:w-auto lg:items-end lg:flex-row w-full items-center flex-col">
                      <div className="flex items-center">
                        by {bookAuthor()}{' '}
                        <button
                          onClick={() => setShowEditEditor(true)}
                          aria-label="Edit title"
                          title="Edit title"
                          className="hover:opacity-80 transition-opacity cursor-pointer mx-6"
                        >
                          <img src="/controls/edit-title-icon.svg" alt="" className="w-6" />
                        </button>
                      </div>
                    </h2>
                    <div className="flex items-center">
                      <img src="/image_icon_small.png" alt="image" className="w-[26px]" />
                      <span className="text-xs text-storyblue">
                        {bookData?.creditsPerBookLimit || 0}/{bookData?.creditsPerBookFullLimit || 0}
                      </span>
                    </div>
                  </div>
                  <TitleModal
                    title={bookAuthor()}
                    isTitleModalOpen={showEditEditor}
                    onSave={updateAuthorNameForBook}
                    onClose={() => setShowEditEditor(false)}
                  />
                </div>
              )}
              {showBookCover ? (
                <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                  <ChooseCover
                    bookData={bookData}
                    setShowBookCover={setShowBookCover}
                    showBookCover={showBookCover}
                    setSelectedCoverUrl={setSelectedCoverUrl}
                    selectedCoverUrl={selectedCoverUrl}
                    displayBookPages={displayBookPages}
                    setStateData={setStateData}
                    stateData={stateData}
                  />
                </div>
              ) : (
                <>
                  <StoryPages
                    bookData={bookData}
                    openModal={openModal}
                    edit={true}
                    selectedPage={selectedPage!}
                    loaderImageGeneration={loaderImageGeneration}
                    setShowImageHistory={setShowImageHistory}
                    showImageHistory={showImageHistory}
                    mode={mode}
                    setShowLowCreditModal={setShowLowCreditModal}
                    setShowBookCover={setShowBookCover}
                    showBookCover={showBookCover}
                    selectedCoverUrl={selectedCoverUrl}
                    displayBookPages={displayBookPages}
                    setStateData={setStateData}
                    stateData={stateData}
                    summaryModal={summaryModal}
                    setSummaryModal={setSummaryModal}
                    setShowStoryForm={setShowStoryForm}
                    setimageCharacterPrompt={setimageCharacterPrompt}
                    imageCharacterPrompt={imageCharacterPrompt}
                    showEditTextIllustration={showEditTextIllustration}
                    setShowEditTextIllustration={setShowEditTextIllustration}
                    editing={editing}
                    setEditing={setEditing}
                    setShowCharacterLibrary={setShowCharacterLibrary}
                  />
                </>
              )}
              {/* Modal for editing page data */}
              <PageModal
                bookId={bookId!}
                pageData={selectedPage}
                onClose={() => closeModal()}
                modalMode={modalMode}
                modalOpen={modalOpen}
                displayBookPages={displayBookPages}
                setShowLowCreditModal={setShowLowCreditModal}
                setLoadingStatus={setLoadingStatus}
              />
            </div>
          )}
        {/*{stateData?.showDownloadPDF && !summaryModal && (*/}
        {/*  <div className="text-center mt-8 w-full flex justify-center ">*/}
        {/*    <Button*/}
        {/*      disabled={!imagesGenerated}*/}
        {/*      tooltip={imagesGenerated ? 'Flip Book' : 'Download PDF Once All Images Generated'}*/}
        {/*      title={`${user?.plan?.freePhysicalBookStatus === true &&*/}
        {/*      +(user?.freePhysicalBookCreated ? user?.freePhysicalBookCreated : 0) <*/}
        {/*      +(user?.freePhysicalBookQuantity ?? 0)*/}
        {/*        ? 'Flip Book / Redeem Book'*/}
        {/*        : 'Flip Book / Purchase Book'*/}
        {/*      }`}*/}
        {/*      loader={loader}*/}
        {/*      onClick={startStepSix}*/}
        {/*      className={`submit-button bg-storyblue text-white font-medium md:font-bold rounded-md text-sm md:text-base h-11 items-center w-[64vw] mb-2 ${imagesGenerated ? '' : 'opacity-50'*/}
        {/*      }`}*/}
        {/*    />*/}
        {/*  </div>*/}
        {/*)}*/}
      </div>

      <InformNotificationPopup
        isOpen={showLowCreditModal}
        onClose={() => closeLowCreditModal()}
        title={'Image credits exhausted'}
      >
        <ImageCreditsLimitPopup></ImageCreditsLimitPopup>
      </InformNotificationPopup>
    </>
  );
};

export default StepStoryBuilder;
